import { grayColor, primaryColor, successColor } from 'assets/jss/material-dashboard-pro-react';
import { dangerColor } from '../../../../material-dashboard-pro-react';

const addNewMicroBundleStyle = (theme) => ({
	labelDiv: {
		margin: '1rem 0 1rem 0',
	},
	asterik: {
		color: dangerColor[0],
	},
	noBorder: {
		'& .MuiFilledInput-root': {
			background: 'linear-gradient(0deg, #F3F2F2, #F3F2F2),linear-gradient(0deg, #F3F2F2, #F3F2F2)',
			'border-radius': '0px',
			'border-bottom': '1px solid #E3E3E3',
			color: 'grey',
		},
		'& .MuiOutlinedInput-root': { 'border-radius': '0px' },
		'& .MuiInputBase-input': {
			padding: '1rem',
		},
		'& .MuiFilledInput-underline:after': {
			'border-bottom': 'none !important',
		},
		margin: '15px',
		'& .Mui-error': {
			fontFamily: theme.fontFamily.albert.regular,
			fontSize: theme.fontSize(14),
			lineHeight: theme.fontSize(24),
		},
	},
	formWrapper: {
		width: '70%',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
		},
		[theme.breakpoints.down('md')]: {
			width: '80%',
		},
		'& .MuiFilledInput-underline:before': {
			display: 'none',
		},
		'& input::-webkit-inner-spin-button': {
			'-webkit-appearance': 'none',
			margin: '0',
		},
	},
	packageWrapper: {
		'margin-top': '24px',
		display: 'inline-grid',
		'column-gap': '5rem',
		'row-gap': '1rem',
		'margin-bottom': '24px',
		[theme.breakpoints.down('sm')]: {
			display: 'inline-grid',
			'column-gap': '5rem',
			'row-gap': '1rem',
		},
	},
	packageDiv: {
		display: 'flex',
	},
	packageName: {
		margin: '.1rem 0 0 0.4rem',
		'font-size': 'medium',
	},
	contactTextfieldWrapper: {
		display: 'flex',
	},
	contactCodeTextField: {
		width: '6rem',
	},
	modalWrapper: {
		'padding-bottom': '2rem',
		'margin-left': '2rem',
	},
	modalBody: {
		margin: '0.8rem',
	},
	navButtonWrapper: {
		display: 'flex',
		'flex-direction': 'row-reverse',
		padding: '2rem',
	},
	cardContentWrapper: {
		display: 'flex',
		'justify-content': 'space-between',
		'align-items': 'center',
		[theme.breakpoints.down('sm')]: {
			'flex-direction': 'column',
			'justify-content': 'flex-start',
			'align-items': 'flex-start',
		},
	},
	buttonWrapper: {
		[theme.breakpoints.down('sm')]: {
			display: 'flex',
			width: '100%',
			'justify-content': 'flex-end',
			'margin-top': 20,
		},
		addMBWrapper: {
			width: '100%',
		},
	},
	addMBWrapper: {
		width: '100%',
	},
	headerWrapper: {
		'margin-bottom': '8px',
		display: 'flex',
		'justify-content': 'flex-start',
		'align-items': 'center',
	},
	badge: {
		'margin-left': '8px',
	},
	planComponentWrapper: {
		'min-height': '60vh',
	},
	componentWrapper: {
		display: 'flex',
		'justify-content': 'center',
		width: '100%',
	},
	dividerMargin: {
		margin: '4rem 0 1rem 0',
	},
	cardBody: {
		width: '50rem',
		padding: '0.5rem',
	},
	linkClass: {
		cursor: 'pointer',
	},
	serviceInfoComponentWrapper: {
		display: 'grid',
		'grid-template-columns': 'auto auto',
		'column-gap': '10rem',
		padding: '1rem 0 1rem 3rem',
		[theme.breakpoints.down('md')]: {
			display: 'block',
		},
		[theme.breakpoints.down('sm')]: {
			display: 'block',
		},
	},
	serviceInfoHeader: {
		fontSize: 17,
		marginBottom: 24,
	},
	serviceInfoContent: {
		'min-width': '20rem',
		display: 'flex',
		[theme.breakpoints.down('md')]: {
			'min-width': 'auto',
		},
	},
	serviceInfoKey: {
		color: `${grayColor[4]} !important`,
		'margin-right': '.5rem',
	},
	serviceInfo: {
		color: `${grayColor[23]}`,
	},
	serviceInfoCircleIcon: {
		color: successColor[0],
		paddingRight: 5,
	},
	serviceInfoFooter: {
		width: '-webkit-fill-available',
		marginTop: 35,
	},
	webHostingAcknowledge: {},
	flexAndInline: {
		display: 'flex',
	},
	infoClauseContainer: {
		'margin-top': '2rem',
		'margin-bottom': '2rem',
	},
	plansCardWrapper: {
		'min-height': '52vh',
		display: 'flex',
		gap: '2rem',
		'margin-top': '1rem',
		[theme.breakpoints.down('sm')]: {
			display: 'block',
			gap: '2rem',
			'margin-top': '1rem',
		},
	},
	paginationWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		[theme.breakpoints.down('sm')]: {
			display: 'flex',
			'flex-direction': 'row-reverse',
		},
	},
	circle: {
		color: successColor[0],
		width: '1rem',
	},
	customTypo: {
		fontFamily: theme.fontFamily.albert.regular,
		fontSize: theme.fontSize(14),
		lineHeight: theme.fontSize(24),
	},
	secondaryBrand: {
		color: '#ff9e1b',
		marginRight: '10px',
	},
});

export default addNewMicroBundleStyle;
